var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sidebar-detail__section"},[_vm._m(0),_vm._l((_vm.trafficMessages),function(message,index){return _c('POIResultsItem',{key:index,attrs:{"poi":message}})})],2)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"sidebar__section sidebar__section--border-top-huge sidebar__section--larger-top-vertical-padding"},[_c('span',{staticClass:"copy-light-small"},[_vm._v("Verkehrsmeldungen")])])
}]

export { render, staticRenderFns }